// src/contexts/TimezoneContext.js

import React, { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";

const TimezoneContext = createContext();

export const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (!context) {
    throw new Error("useTimezone must be used within a TimezoneProvider");
  }
  return context;
};

export const TimezoneProvider = ({ children }) => {
  const [orgTimeZone, setOrgTimeZone] = useState("UTC");
  const [loading, setLoading] = useState(true);
  
  // Listen to Redux user state changes
  const { user, status } = useSelector((state) => state.user);

  useEffect(() => {
    // Update timezone when user data changes - using currentOrganization
    if (status === "success" && user && user.currentOrganization && user.currentOrganization.timeZone) {
      setOrgTimeZone(user.currentOrganization.timeZone);
      setLoading(false);
    } else if (status === "success") {
      // User is loaded but no organization or timezone, keep UTC
      setOrgTimeZone("UTC");
      setLoading(false);
    } else if (status === "loading") {
      setLoading(true);
    }
  }, [user, status]);

  const value = {
    orgTimeZone,
    setOrgTimeZone,
    loading,
    // Helper function to get user's browser timezone
    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  return (
    <TimezoneContext.Provider value={value}>
      {children}
    </TimezoneContext.Provider>
  );
}; 